import BillingPage from "./BillingPage";
import { BillingPath } from "v2/pages/billing/BillingPath";


export const path = BillingPath;

export const Component = BillingPage;
